module.exports = __webpack_public_path__ + "static/img/title-pt.daa3fc60.png";